const ROUTES = {
  COMMON_CHAT: "/common-chat",
  EXIT_ROUTE: "/exit",
  LOGOUT: "/logout",
  NOT_FOUND: "/shikshagraha-not-found",
  
  SHIKSHAGRAHA_REPOSITORY_DETAIL: "/:id",
  SHIKSHAGRAHA_REPOSITORY: "/",
  
  SHIKSHALOKAM_GUEST_LISTENING_CHAT: "/guest-listen",
  SHIKSHALOKAM_GUEST_MI_STORY: "/guest-mi",
  SHIKSHALOKAM_GUEST_PAGE: "/flow",
  SHIKSHALOKAM_GUEST_VOICE_CHAT: "/guest-chat",
  SHIKSHALOKAM_HOME_PAGE: "/home",
  SHIKSHALOKAM_PPPI_VOICE_CHAT: "/survey-chat",
  SHIKSHALOKAM_PTM_CHAT_PAGE: "/ptm/chat",
  SHIKSHALOKAM_PTM_HOME_PAGE: "/ptm/start",
  SHIKSHALOKAM_VOICE_CHAT_LOGIN: "/login",
  SHIKSHALOKAM_VOICE_CHAT: "/voice-chat",
  SHIKSHALOKAM_YLC_CHAT_PAGE: "/ylc/chat",
  SHIKSHALOKAM_YLC_HOME_PAGE: "/ylc/start",
  SSO_FLOW: "/sso",
  TERMS_AND_CONDITIONS: "/tnc",
  SHIKSHAGRAHA_REPOSITORY_MITRA_AI_ASSISTANT: "/mitra-chat",
  MITRA_CHAT: "/mitra-chat",
  IMPROVEMENT_PLAN: "/improvement-plan",
  LOGIN: "/login",
  EXPLORE: "/explore"
}

export default ROUTES
